/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminAmmo
 */
export interface InputAdminAmmo {
    /**
     * 
     * @type {string}
     * @memberof InputAdminAmmo
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminAmmo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InputAdminAmmo
     */
    video?: string;
}

/**
 * Check if a given object implements the InputAdminAmmo interface.
 */
export function instanceOfInputAdminAmmo(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputAdminAmmoFromJSON(json: any): InputAdminAmmo {
    return InputAdminAmmoFromJSONTyped(json, false);
}

export function InputAdminAmmoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminAmmo {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'name': json['name'],
        'video': json['video'] == null ? undefined : json['video'],
    };
}

export function InputAdminAmmoToJSON(value?: InputAdminAmmo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'name': value['name'],
        'video': value['video'],
    };
}

